/**
 * @generated SignedSource<<f4f0951a1c333efd61ce875b98ffe2ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articlePaywallCheckerArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"hooksPaywallPromiseArticle">;
  readonly " $fragmentType": "articlePaywallCheckerArticle";
};
export type articlePaywallCheckerArticle$key = {
  readonly " $data"?: articlePaywallCheckerArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articlePaywallCheckerArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articlePaywallCheckerArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksPaywallPromiseArticle"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "a8787b21a91fbb69b3f96f74ed2d6207";

export default node;
